import './sharingGroupUsers.scss';

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { withLocalize, Translate } from 'react-localize-redux';
import classnames from 'classnames';
import { apiGet, apiPut, apiPost, apiDelete, getHostApi } from '../../store/apiWrapper';
import { popupActions } from '../../store/popupStore';
import { isNullOrUndefined, validateInput } from '../../store/storeFunctions';
import { Field, Formik, Form } from 'formik';
import generateLabel from './userLabelGenerator';
import Widget from '../common/widget';
import Message from '../common/message';
import { Circles } from '../common/loadingComponent';
import { BbSelectNoFormik } from '../styling/bbInput'
import BbCheckbox from '../styling/bbCheckbox';
import ResponsiveTable from '../layoutItems/responsiveTable';

import EditIcon from "../../img/icons/Upravit";
import SaveIcon from "../../img/icons/BBicons_Ulozit";
import DeleteIcon from "../../img/icons/BBiconsOdstranit";

class SharingGroupUsers extends React.Component {
    mounted = true;

    state = {
        group: null, groupLoading: false, groupError: null, groupEditing: false,
        users: [], usersMap: {}, usersLoading: false, usersError: null,
        userAdding: false, userAddingError: null,
        userDeleting: false, userDeletingError: null,
        userAddInitValue: { user: null },
        toAddId: 0,
        toAddNew: [],
        toDelete: {},
        editingName: false
    };

    componentDidMount() {
        this.setState({ group: null, groupError: null, groupLoading: true, users: [], usersMap: {}, usersError: null, usersLoading: true });
        apiGet(`${getHostApi()}/api/account/sharing-groups/${this.props.match.params.id}`, null,
            res => this.mounted && this.setState(state => ({
                group: res.data, groupLoading: false, userAddInitValue: { user: this.getFirstUser(state.users, res.data.users) }
            })),
            _ => this.mounted && this.setState({ groupError: this.props.translate('Common.Error'), groupLoading: false })
        );
        apiGet(`${getHostApi()}/api/account/users`, null,
            res => {
                if (!this.mounted) {
                    return;
                }

                const usersMap = {};
                res.data.forEach(u => usersMap[u.id] = u);

                const sortedUsers = res.data.sort(this.userCompare);

                this.setState(state => ({
                    users: sortedUsers,
                    usersMap: usersMap,
                    userAddInitValue: { user: this.getFirstUser(sortedUsers, state.group && state.group.users) },
                    usersLoading: false
                }));
            },
            _ => this.mounted && this.setState({ usersError: this.props.translate('Common.Error'), usersLoading: false })
        );
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        const showTable = this.state.group && (this.state.group.users.length > 0 || this.state.toAddNew.length > 0) && this.state.usersMap;

        return (
            <div className='content-root sharing-group-users-content-root'>
                <Widget
                    className='widget' hideHeader
                    isLoading={this.isWorking()} initialExpanded={true}
                >
                    {this.isWorking() ? <Circles /> : <>
                        <div className="columns">
                            <div className="column is-11">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        groupTitle: ""
                                    }}
                                    onSubmit={() => { }}
                                    render={({ values }) => (
                                        <Form noValidate>
                                            {this.renderTitle(values)}
                                        </Form>
                                    )} />
                            </div>
                        </div>
                        {(this.state.groupError || this.state.usersError) &&
                            <><Message type='error' message={this.state.groupError ? this.state.groupError : this.state.usersError} /><br /></>
                        }
                        {this.state.userAddingError && <><Message type='error' message={this.state.userAddingError} /><br /></>}
                        {this.state.userDeletingError && <><Message type='error' message={this.state.userDeletingError} /><br /></>}
                        {this.state.group &&
                            <div style={{ paddingBottom: '15px' }}>
                                <button className={classnames('bb-button small is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.addEmptyUser()}><Translate id="Common.Button.AddUser" /></button>
                            </div>}
                        {this.state.group && (this.state.group.users.length < 1 && this.state.toAddNew.length < 1) && <p>{this.props.translate('User.SharingGroups.NoUserFound')}</p>}
                        {showTable && <>
                            <ResponsiveTable>
                                <table className='table table-report-section table-centered'>
                                    <colgroup>
                                        <col width="3%" />
                                        <col width="24%" />
                                        <col width="24%" />
                                        <col width="49%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th className='fitwidth'><BbCheckbox id="all-chk" customStyle={{ justifyItems: "right" }} onChange={(v) => this.selectAllToDelete(v)} value={this.areAllSelected()} /></th>
                                            <th><Translate id='Common.Login' /></th>
                                            <th><Translate id='User.SharingGroups.UserName' /></th>
                                            <th className='align-right'><Translate id="Common.Actions" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>{
                                        this.state.group.users
                                            .filter(u => this.state.usersMap[u])
                                            .map(u => this.state.usersMap[u])
                                            .sort(this.userCompare)
                                            .map(u => (
                                                <tr className='colorize' key={u.id}>
                                                    <td data-label={this.props.translate('Common.Mark')}>
                                                        {this.renderCheckBox(u.id)}
                                                    </td>
                                                    <td data-label={this.props.translate('Common.Login')}><span>{u.userName}</span></td>
                                                    <td data-label={this.props.translate('User.SharingGroups.UserName')}>
                                                        <span>{`${u.firstName} ${u.surname}`}</span>
                                                    </td>
                                                    <td className='align-right' data-label={this.props.translate('Common.Actions')}>
                                                        {this.renderDeleteLink(_ => this.deleteUser(u.id))}
                                                    </td>
                                                </tr>
                                            ))}

                                        {Object.keys(this.state.toAddNew).map(id => (
                                            <tr className='colorize' key={this.state.toAddNew[id]}>
                                                <td data-label={this.props.translate('Common.Mark')}>
                                                    {this.renderCheckBox(this.state.toAddNew[id])}
                                                </td>
                                                <td colSpan={2} className="sharing-select">
                                                    <BbSelectNoFormik
                                                        className='field'
                                                        options={
                                                            (this.state.group ?
                                                                this.state.users.filter(u => !this.state.group.users.find(gu => gu === u.id) && !Object.keys(this.state.toAddNew).find(key => this.state.toAddNew[key] === u.id)) : this.state.users
                                                            )
                                                                .map(user => ({ label: generateLabel(user.firstName, user.surname, user.userName), value: user.id }))
                                                        }
                                                        selectPlaceholder={`${this.props.translate("Common.User")}...`}
                                                        value={this.getUser(this.state.toAddNew[id])}
                                                        onChange={e => this.updateEmptyUser(this.state.toAddNew[id], e)}
                                                    />
                                                </td>
                                                <td className='align-right' data-label={this.props.translate('Common.Actions')}>
                                                    {this.renderDeleteLink(_ => this.deleteUserFromToAdd(this.state.toAddNew[id]))}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </ResponsiveTable>
                        </>}
                        <div className='column'>
                            <div className='button-wrapper'>
                                {showTable && <a className={classnames('link-functional', { 'is-disabled': (Object.keys(this.state.toDelete).length === 0 || this.isWorking()) })}
                                    onClick={() => this.deleteUsers(false)}
                                >
                                    <Translate id='Common.DeleteSelected' />
                                </a>}
                                <div>
                                    <button
                                        className={classnames('bb-button is-primary gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}
                                        onClick={() => this.props.history.push(`/user/sharing-groups`)}
                                    >
                                        <Translate id='Common.Back' />
                                    </button>
                                    {showTable && <button
                                        className={classnames(
                                            'bb-button bold-bb-button is-primary gradient-1',
                                            { 'disabled': this.state.toAddNew.length === 0 || this.state.toAddNew.filter(id => id > 0).length !== this.state.toAddNew.length || this.isWorking() }
                                        )}
                                        onClick={() => this.addUsers()}
                                        disabled={this.state.toAddNew.length === 0 || this.state.toAddNew.filter(id => id > 0).length !== this.state.toAddNew.length || this.isWorking()}
                                    >
                                        <Translate id='Common.Save' />
                                    </button>}
                                </div>
                            </div>
                        </div>
                    </>}
                </Widget>
            </div >
        )
    }

    renderTitle = (values) => {
        return (
            <div className="monitoring-header-wrapper" >
                {this.state.editingName
                    ? <Field type="text" name="groupTitle" placeholder={`${this.state.group ? `${this.state.group.title}` : ''}`}
                        className="input form-control" style={{ width: "50%" }}
                        onInput={(e) => validateInput(e)}
                    />
                    : <h1 className="monitoring-header equal-height">{`${this.props.translate('User.SharingGroups.Group')}${this.state.group ? ` - ${this.state.group.title}` : ''}`}</h1>
                }
                <div className="ml-link color">
                    <div className="ml-link-inner">
                        {this.state.editingName ? <a className='link-internal' onClick={() => this.onNameEditClick(values)}>
                            <SaveIcon className="ml-link-icon" />
                            <Translate id="Common.Button.Save" />
                        </a> : <a className='link-internal' style={{ alignItems: "center" }} onClick={() => this.setState({ editingName: true })}>
                            <EditIcon className="ml-link-icon" />
                            <Translate id="Common.Button.Edit" />
                        </a>}
                    </div>
                </div>
            </div>
        );
    }

    renderCheckBox = (id) => {
        return (
            <BbCheckbox
                value={this.state.toDelete[id] || false} id={`${id}`}
                onChange={e => e ?
                    this.setState(state => ({ toDelete: { ...state.toDelete, [id]: true } })) :
                    this.setState(state => {
                        let toDelete = { ...state.toDelete };
                        delete toDelete[id];
                        return { toDelete: toDelete }
                    })
                } />
        );
    }

    renderDeleteLink = (onClickFunc) => {
        return (
            <div className="ml-link color">
                <div className="ml-link-inner">
                    <a className="link-internal" onClick={e => onClickFunc(e)}>
                        <DeleteIcon className='ml-link-icon' />
                        <Translate id='Common.Button.Delete' />
                    </a>
                </div>
            </div>
        );
    }

    onNameEditClick = (values) => {
        this.setState({ editingName: false });

        if (values.groupTitle === "") {
            this.props.showPopup('informationMessagePopup', {
                open: true,
                close: () => this.props.hidePopup(),
                message: this.props.translate('Form.Validation.Required').replace('${name}', this.props.translate('Common.Title'))
            });
        }
        else
            this.submitEditName(values.groupTitle);
    }

    submitEditName(groupTitle) {
        if (!isNullOrUndefined(groupTitle) && groupTitle !== "") {
            this.setState({ groupEditing: true });
            apiPut(
                `${getHostApi()}/api/account/sharing-groups/${this.props.match.params.id}`, null, groupTitle,
                _ => this.mounted &&
                    this.setState(state => ({
                        groupEditing: false,
                        group: { ...state.group, title: groupTitle }
                    })),
                _ => this.mounted && this.setState({ groupEditing: false }),
            );
        }
    }

    addEmptyUser = () => {
        this.setState(state => ({
            toAddId: this.state.toAddId - 1,
            toAddNew: state.toAddNew.concat([state.toAddId - 1])
        }))
    }

    updateEmptyUser = (id, value) => {
        let toAdd = this.state.toAddNew;
        const index = toAdd.indexOf(parseInt(id));
        toAdd.splice(index, 1, value.value);
        this.setState({ toAddNew: toAdd })
    }

    addUsers = () => {
        const toAddArr = this.state.toAddNew.map(id => parseInt(id));
        const concatToAddArr = this.state.group.users.concat(toAddArr);

        if (this.state.users && this.state.group && !this.isWorking() && Object.keys(this.state.toAddNew).length > 0) {
            this.setState({ userAdding: true, userAddingError: null });
            apiPost(`${getHostApi()}/api/account/sharing-groups/${this.props.match.params.id}/users`, null, toAddArr,
                _ => this.mounted &&
                    this.setState(state => ({
                        userAdding: false,
                        toAddNew: [],
                        userAddInitValue: { user: this.getFirstUser(state.users, concatToAddArr) },
                        group: { ...state.group, users: concatToAddArr }
                    })),
                _ => this.mounted && this.setState({ userAdding: false, userAddingError: this.props.translate('Common.Error') })
            );
        }
    }

    deleteUser = (deleteId) => {
        const remainingUsers = this.state.group.users.filter(id => id !== deleteId);
        let remainingUsersToDelete = { ...this.state.toDelete };
        delete remainingUsersToDelete[deleteId];

        if (this.state.users && this.state.group && !this.isWorking()) {
            this.setState({ userDeleting: true, userDeletingError: null });

            apiDelete(`${getHostApi()}/api/account/sharing-groups/${this.props.match.params.id}/users`,
                null, [deleteId],
                _ => this.mounted && this.setState(state => ({
                    userDeleting: false,
                    toDelete: remainingUsersToDelete,
                    userAddInitValue: { user: this.getFirstUser(state.users, remainingUsers) },
                    group: { ...state.group, users: remainingUsers }
                })),
                _ => this.mounted && this.setState({ userDeleting: false, userDeletingError: this.props.translate('Common.Error') })
            );
        }
    }

    deleteUserFromToAdd = (deleteId) => {
        const remainingUSersToAdd = this.state.toAddNew.filter(addId => addId !== deleteId);

        let remainingUsersToDelete = { ...this.state.toDelete };
        delete remainingUsersToDelete[deleteId];

        this.setState(state => ({ toAddNew: remainingUSersToAdd, toDelete: remainingUsersToDelete }))
    }

    deleteUsers = (deleteAll) => {
        const toDelete = deleteAll ? this.state.group.users.map(id => parseInt(id)) : Object.keys(this.state.toDelete).map(id => parseInt(id));
        const usersToDelete = toDelete.filter(id => !this.state.toAddNew.find(addId => id === addId));
        const remainingUsers = this.state.group.users.filter(id => !toDelete.find(delId => id === delId));
        const remainingUsersToAdd = this.state.toAddNew.filter(id => !toDelete.find(delId => id === delId));

        if (this.state.users && this.state.group && !this.isWorking() && toDelete.length > 0) {
            this.setState(() => {
                return { toAddNew: remainingUsersToAdd, toDelete: usersToDelete }
            }, () => {
                if (usersToDelete.length > 0) {
                    this.setState({ userDeleting: true, userDeletingError: null });

                    apiDelete(`${getHostApi()}/api/account/sharing-groups/${this.props.match.params.id}/users`, null, usersToDelete,
                        _ => this.mounted &&
                            this.setState(state => ({
                                userDeleting: false,
                                toDelete: {},
                                userAddInitValue: { user: this.getFirstUser(state.users, remainingUsers) },
                                group: { ...state.group, users: remainingUsers }
                            })),
                        _ => this.mounted && this.setState({ userDeleting: false, userDeletingError: this.props.translate('Common.Error') })
                    );
                }
            })
        }
    }

    getFirstUser = (users, groupUsersIds) => {
        if (!users || users.length < 1) {
            return null;
        }
        const user = groupUsersIds ? users.find(u => !groupUsersIds.find(gu => gu === u.id)) : users[0];
        return user && { label: generateLabel(user.firstName, user.surname, user.userName), value: user.id }
    }

    getUser = (userId) => {
        const user = this.state.usersMap[userId];
        return user && { label: generateLabel(user.firstName, user.surname, user.userName), value: user.id }
    }

    selectAllToDelete = (value) =>
        this.setState(state => {
            if (value) {
                const toDelete = {};
                state.group.users.forEach(id => toDelete[id] = true);
                return { toDelete };
            } else {
                return { toDelete: {} };
            }
        });

    areAllSelected = () => {
        var toDeleteCount = Object.keys(this.state.toDelete).length;
        return (toDeleteCount === 0) ? false : (toDeleteCount === this.state.group.users.length ? true : null);
    }

    userCompare = (u1, u2) => `${u1.surname}${u1.firstName}${u1.userName}`.localeCompare(`${u2.surname}${u2.firstName}${u2.userName}`);

    isWorking = () => this.state.usersLoading || this.state.groupLoading || this.state.userAdding || this.state.userDeleting || this.state.groupEditing;
}

export default withLocalize(withRouter(connect(
    state => state.popup, dispatch => bindActionCreators(popupActions, dispatch)
)(SharingGroupUsers)));